import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '.'

export enum PageType {
  MainPage = 'MAIN_PAGE',
  Settings = 'SETTINGS'
}

const initialState = {
  page: PageType.MainPage,
  anchor: ''
}

const pageSlice = createSlice({
  name: 'page',
  initialState,
  reducers: {
    setAnchor(state, action: PayloadAction<string>) {
      state.anchor = action.payload
    },
    changePage(state, action: PayloadAction<PageType>) {
      state.page = action.payload
    },
    resetAnchor(state) {
      state.anchor = ''
    }
  }
})

export const { changePage, setAnchor, resetAnchor } = pageSlice.actions
export default pageSlice.reducer

export const selectPage = (state: RootState) => state.page.page
